module.exports = __webpack_public_path__ + "img/header.f9f3def0.png";